import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StartComponent } from './pages/start/start.component';
import { TrustComponent } from './pages/trust/trust.component';
import { EstateComponent } from './pages/estate/estate.component';
import { TrustFundComponent } from './pages/info/trust-fund/trust-fund.component';
import { EstatePlanningComponent } from './pages/info/estate-planning/estate-planning.component';
import { AppointmentsComponent } from './pages/estate/appointments/appointments.component';

import { Step8CompleteComponent as Step8Milele } from './pages/trust/step8-complete/step8-complete.component';
import { Step8CompleteComponent as Step8Estate } from './pages/estate/private-trust/step8-complete/step8-complete.component';
import { LegalConsultationComponent } from './pages/estate/legal-consultation/legal-consultation.component';
import { GrantLetterComponent } from './util/PDF/grant-letter/grant-letter.component';
import { StepSummaryComponent } from './pages/estate/appointments/step-summary/step-summary.component';
import { RegionComponent } from './pages/region/region.component';
import { SetupComponent } from './pages/estate/setup/setup.component';
import { MedicalComponent } from './pages/info/medical/medical.component';



const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/get-started'},
  { path: 'get-started', component: StartComponent},
  { path: 'pdf/grant', component: GrantLetterComponent},

  { path: 'estate-planning/region', component: RegionComponent},
  { path: 'trust-fund/region', component: RegionComponent},

  // Milele trust
  { path: 'trust-fund/set-up', component: TrustComponent},
  { path: 'milele-trust/success', component: Step8Milele},
  
  // Estate Planning
  { path: 'estate-planning/appointment', component: AppointmentsComponent},
  { path: 'estate-planning', component: EstateComponent},
  { path: 'estate-planning/set-up', component: SetupComponent},
  { path: 'estate-planning/success', component: Step8Estate},
  { path: 'estate-planning/legal-consultaion', component: LegalConsultationComponent},

  { path: 'estate-planning/appointments/success', component: StepSummaryComponent},

  { path: 'info/trust-fund', component: TrustFundComponent},
  { path: 'info/estate-planning', component: EstatePlanningComponent},
  { path: 'info/medical-trust', component: MedicalComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
